<script setup lang="ts">
import { Menu } from '@headlessui/vue'
import { provide, ref } from 'vue'
import { DTDropdownProvider } from '../../keys'

defineEmits<{
  (e: 'close'): void
  (e: 'open'): void
}>()

const trigger = ref<HTMLElement>()
provide(DTDropdownProvider, {
  getTrigger: () => trigger.value,
  registerTrigger: el => trigger.value = el,
})
</script>

<template>
  <Menu
    v-slot="{ close, open }"
    as="div"
    class="relative inline-block text-left antialiased"
  >
    <slot
      :close="close as () => void"
      :open="open as boolean"
    />
    <DTOpenedStateEmitter
      :open="open"
      @open="$emit('open')"
      @close="$emit('close')"
    />
  </Menu>
</template>
